export default "__VITE_ASSET__Bz_y1d0P__"